// extracted by mini-css-extract-plugin
export default {"container":"CroppedImage_container__if7tJ","badgeContainer":"CroppedImage_badgeContainer__hcfU8","badgeContent":"CroppedImage_badgeContent__RY7Iz"};